import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgCompare(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 0 16 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2v20h-1.5v-1.5H5a1 1 0 01-1-1v-15a1 1 0 011-1h5.5V2H12zm-2 12.5H7V16h3v-1.5zm0-3H7V13h3v-1.5zm0-3H7V10h3V8.5zM14.555 3.5c.49 0 .961.154 1.34.434l.139.111 3.29 2.886c.384.336.62.789.667 1.272l.009.182V19.5c0 .515-.617.94-1.183.994l-.12.006H13v-2h4.885V9.538h-2.026c-.614 0-1.118-.327-1.182-.857l-.007-.116V5.5H13v-2h1.555zm2.214 11V16H13v-1.5h3.77zm0-3V13H13v-1.5h3.77z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Compare')(SvgCompare);
